<template>
  <div class="h-full bg-gradient">
    <router-view></router-view>
  </div>
</template>
<style>
.bg-gradient {
  background: linear-gradient(160deg, #0b1734, #0b1734, #01186a);
}
</style>
